declare global {
  interface Window {
    Swiper: any;
  }
}

export function initBfHighlight(root: ParentNode = document): void {
  const sections = root.querySelectorAll<HTMLElement>('[data-bf-highlight]');
  if (!sections.length) return;

  if (typeof window.Swiper !== 'function') {
    setTimeout(() => initBfHighlight(root), 50);
    return;
  }

  for (const section of Array.from(sections)) {
    if (section.dataset.bfHighlightInit === '1') continue;
    section.dataset.bfHighlightInit = '1';

    const card = section.querySelector('.product-card');
    const imageSwiperEl = card?.querySelector<HTMLElement>('.product-image-swiper');
    const swatchSwiperEl = card?.querySelector<HTMLElement>('.swatch-swiper');
    const productLink = card?.querySelector<HTMLAnchorElement>('.product-link');
    const ctaLink = section.querySelector<HTMLAnchorElement>('[data-cta-link]');
    if (!imageSwiperEl || !swatchSwiperEl) continue;

    const imageSwiper = new window.Swiper(imageSwiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
    });

    const swatchSwiper = new window.Swiper(swatchSwiperEl, {
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesProgress: true,
    });

    const swatchSlides = swatchSwiperEl.querySelectorAll<HTMLElement>('.swatch-slide');

    const updateLinks = (slide: HTMLElement) => {
      const url = slide.dataset.url || '';

      if (productLink) productLink.setAttribute('href', url);
      if (ctaLink) ctaLink.setAttribute('href', url);
    };

    swatchSlides.forEach((swatch) => {
      swatch.addEventListener('click', () => {
        const color = swatch.dataset.color;
        if (!color) return;

        const idx = Array.from(imageSwiper.slides).findIndex(
          (s) => (s as HTMLElement).dataset.color === color
        );
        if (idx !== -1) {
          imageSwiper.slideTo(idx);
          swatchSlides.forEach((s) => s.classList.remove('active-swatch'));
          swatch.classList.add('active-swatch');
        }
      });
    });

    imageSwiper.on('slideChange', () => {
      const active = imageSwiper.slides[imageSwiper.activeIndex] as HTMLElement;
      if (!active) return;
      const color = active.dataset.color;
      updateLinks(active);

      swatchSlides.forEach((s) => {
        const match = s.dataset.color === color;
        s.classList.toggle('active-swatch', match);
      });
    });

    if (imageSwiper.slides.length > 0) {
      const firstSlide = imageSwiper.slides[0] as HTMLElement;
      updateLinks(firstSlide);
      const firstColor = firstSlide.dataset.color;
      swatchSlides.forEach((s, i) => {
        if (s.dataset.color === firstColor) {
          s.classList.add('active-swatch');
          try {
            swatchSwiper.slideTo(i, 0);
          } catch {}
        }
      });
    }
  }
}
